// extracted by mini-css-extract-plugin
export default {"card":"VvxjA","image":"cp2ol","picture-card":"Wkdg2","link":"Ke1Os","link-arrow":"opBzn","video-wrapper":"VpIrA"};